import styled from 'styled-components';

import { neutralTrans } from 'enable-ui';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export const Schedule = styled.div<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  background-color: ${COLOR_CONFIG.white} !important;
  border: 1px solid ${COLOR.neutralTrans['neutralTrans-25']};
  border-radius: 12px;

  div:last-child {
    border: none;
  }

  .hyphen {
    color: ${(props) =>
      props.$disabled ? neutralTrans['neutralTrans-25'] : COLOR.surfaceNeutralBold['neutral-11']};
  }

  background-color: ${(props) =>
    props.$disabled ? neutralTrans['neutralTrans-3'] : 'transparent'};
  .text-input-wrapper {
    border-radius: 12px;
    height: 32px;
  }

  .text-input {
    background-color: ${COLOR_CONFIG.white} !important;
    border-radius: 12px;
    padding: 6px 12px;
  }
`;

export const CustomTooltip = styled.div`
  .tippy-content {
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 12px;
    padding: 0;
    width: 240px;
    p {
      font-size: 18px;
      line-height: 26px;
      color: #222222;
      padding: 10px 0;
      margin-left: 0;
    }
  }
`;

export const ModalWrapperAbsent = styled.div`
  .es-modal {
    background: ${COLOR_CONFIG.white};
  }

  .es-modal-body {
    max-height: 600px;
    overflow: auto;
  }
`;

export const LessonTableContainer = styled.div`
  overflow: auto;

  /* For WebKit-based browsers (Chrome, Safari) */
  &::-webkit-scrollbar {
    width: 8px; /* Width of the scrollbar */
    height: 8px; /* Height of the horizontal scrollbar */
  }

  &::-webkit-scrollbar-thumb {
    background-color: #f0efee; /* Color of the scrollbar thumb */
    border-radius: 10px; /* Rounded corners for the thumb */
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1; /* Color of the scrollbar track */
    border-radius: 10px; /* Rounded corners for the track */
  }
`;
